import { useId, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useDismiss } from 'src/hooks/use-dismiss';

import { useConsent } from './consent-context';

export function ConsentSettings() {
  const { t } = useTranslation('consent');
  const { consent, saveConsent, closeSettings } = useConsent();

  const titleId = useId();
  const necessaryId = useId();
  const analyticsId = useId();

  const [analytics, setAnalytics] = useState(consent?.analytics ?? false);
  const dialogRef = useDismiss<HTMLDialogElement>(true, closeSettings);

  const handleAnalyticsToggle = useCallback(() => {
    setAnalytics((previous) => !previous);
  }, []);

  const handleSave = useCallback(() => {
    saveConsent({ analytics });
  }, [saveConsent, analytics]);

  const handleAcceptAll = useCallback(() => {
    saveConsent({ analytics: true });
  }, [saveConsent]);

  return (
    <div className="consent-overlay">
      <dialog
        open
        ref={dialogRef}
        aria-modal="true"
        aria-labelledby={titleId}
        className="consent-dialog"
      >
        <h2 id={titleId}>{t('settings.title')}</h2>
        <p>{t('settings.description')}</p>
        <div className="consent-category">
          <div className="consent-category-head">
            <label htmlFor={necessaryId}>{t('settings.categories.necessary.name')}</label>
            <span className="consent-always-on">{t('settings.alwaysOn')}</span>
            <input checked disabled type="checkbox" id={necessaryId} />
          </div>
          <p>{t('settings.categories.necessary.description')}</p>
        </div>
        <div className="consent-category">
          <div className="consent-category-head">
            <label htmlFor={analyticsId}>{t('settings.categories.analytics.name')}</label>
            <input
              type="checkbox"
              id={analyticsId}
              checked={analytics}
              onChange={handleAnalyticsToggle}
            />
          </div>
          <p>{t('settings.categories.analytics.description')}</p>
        </div>
        <div className="consent-actions">
          <button type="button" className="btn btn-blue" onClick={handleAcceptAll}>
            {t('settings.acceptAll')}
          </button>
          <button type="button" onClick={handleSave} className="btn btn-ghost">
            {t('settings.save')}
          </button>
        </div>
        <button
          type="button"
          onClick={closeSettings}
          className="consent-close"
          aria-label={t('settings.close')}
        >
          ×
        </button>
      </dialog>
    </div>
  );
}
